import { ActionType, ProColumns } from '@ant-design/pro-components';
import { Form, Input, message } from 'antd';
import { ROUTES } from 'base/routes/routes';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from "base/ui/components/Button";
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { Download } from 'base/ui/components/Icons';
import useDebounce from 'hooks/useDebounce';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { SearchRewardModel } from 'services/Main/exchangeRewards_services';
import { commonPresenter, commonStore, exchangeRewardsPresenter, exchangeRewardsStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { useCheckPermission } from 'utils/permissionHelper';
import * as Icon from 'base/ui/components/Icons';
import usePartialState from 'hooks/usePartialState';



const createUpdatePage = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    // --------------------------------
    const [form] = Form.useForm();

    let pageTitle = "";
    const [searchParams] = useSearchParams();
    const campaignId = searchParams.get("id");
    const navigate = useNavigate();
    const tableRef = useRef<ActionType>();

    // STATE =================================================================================================
    // STATE =================================================================================================
    // STATE =================================================================================================

    const [programList, setProgramList] = useState<CommonModel[]>([])

    const [columns, setColumns] = useState<ProColumns<SearchRewardModel>[]>([
      // stt
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        width: 30,
        align: 'center',
      },
      //   Mã KH
      {
        title: "Mã khách hàng",
        dataIndex: 'customerCode',
        key: 'customerCode',
        width: 60,
      },
      //   Tên khách hàng
      {
        title: "Tên khách hàng",
        dataIndex: 'customerName',
        key: 'customerName',
        width: 100,
      },
      //   Số điện thoại
      {
        title: "Số điện thoại",
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        width: 60,
      },
      //   Mã chương trình
      {
        title: "Mã chương trình",
        dataIndex: 'programCode',
        key: 'programCode',
        width: 70,
      },
      //   Tên chương trình
      {
        title: "Tên chương trình",
        dataIndex: 'programName',
        key: 'programName',
        width: 100,
        ellipsis: true
      },
      //   Tổng doanh số tích lũy
      {
        title: "Tổng doanh số tích lũy",
        dataIndex: 'totalRevenue',
        key: 'totalRevenue',
        width: 100,
        align: 'right',
        render: (val, record) => (<>{formatNumber(record.totalRevenue, 0)}</>)
      },
      //   DS tích lũy đã đổi quà
      {
        title: "DS tích lũy đã đổi quà",
        dataIndex: 'usedValue',
        key: 'usedValue',
        width: 100,
        align: 'right',
        render: (val, record) => (<>{formatNumber(record.usedValue, 0)}</>)

      },
      //   DS tích lũy còn lại
      {
        title: "DS tích lũy còn lại",
        dataIndex: 'remainRevenue',
        key: 'remainRevenue',
        width: 100,
        align: 'right',
        render: (val, record) => (<>{formatNumber(record.remainRevenue, 0)}</>)

      },
      //   Chức năng
      {
        title: "Chức năng",
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 60,
        align: 'center',
        render: (value, record) => {
          return <div onClick={() => {
            navigate(`reward${record.customerId ? '/' + record.customerId : ''}${record.programId ? '/' + record.programId : ''}`)
          }}
            className='cursor-pointer p-1 bg-red-500 rounded text-white border-[1px]' >Đổi thưởng</div >
        }
      },
    ])
    // data table
    const [dataTable, setDataTable] = useState<SearchRewardModel[]>([]);
    //--- search state ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      isExchangeReward: null
    });

    const [reportState, setReportState] = usePartialState({
      loading: false,
    });

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (campaignId) {
      // Kiểm tra phân quyền
      useCheckPermission("EDIT");
      pageTitle = 'Chỉnh sửa';
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      useCheckPermission("CREATE");
      pageTitle = 'Tra cứu';
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    }

    const layoutSpan = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }

    const getListProgram = async (key?: string) => {
      await commonPresenter.getListProgram(commonStore, key)
      if (commonStore.commonRespone.isSuccess) {
        setProgramList(commonStore.commonRespone.data)
      }
    }
    const debounceListProgram = useDebounce(getListProgram, 500)

    useEffect(() => {
      debounceListProgram()
    }, [])

    const getDataTable = async (dataSearch: any) => {
      await exchangeRewardsPresenter.getSearchCustomerExchangeReward(exchangeRewardsStore, dataSearch);
      if (exchangeRewardsStore.searchReward.isSuccess) {
        const dataTemp = cloneDeep(exchangeRewardsStore.searchReward.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'Quản lý đổi thưởng',
            to: ROUTES.EXCHANGE_REWARDS.MANAGE.LINK,
          },
          {
            text: pageTitle,
          },
        ]}
      >
        <BoxContainer fullHeight>
          <SearchForm
            form={form}
            {...layoutSpan}
            layout="horizontal"
            labelAlign="right"
            column='col-2'
            initialValues={{
              isExchangeReward: null
            }}
          >
            <SearchItem label="Tên chương trình" name={'programId'} >
              <CustomSelect
                options={programList.map((item) => ({
                  label: `${item.value}`,
                  value: item.key,
                }))}
                showSearch
                allowClear
                onSearch={(value) => value ? debounceListProgram(value) : debounceListProgram()}
                onClear={() => debounceListProgram()}
                filterOption={false} />
            </SearchItem>
            <SearchItem start label="Số điện thoại" name={'phoneNumber'} >
              <Input />
            </SearchItem>
            <SearchItem start label="Mã khách hàng" name={'customerCode'} >
              <Input />
            </SearchItem>
            {/* đổi thưởng */}
            <SearchItem start label="Đổi thưởng" name={'isExchangeReward'} >
              <CustomSelect
                options={[
                  {
                    label: 'Đã đổi thưởng',
                    value: true
                  },
                  {
                    label: 'Chưa đổi thưởng',
                    value: false
                  },
                  {
                    label: 'Tất cả',
                    value: null
                  },
                ]}
              />
            </SearchItem>


            <div className='col-span-2 mt-4 flex justify-center items-center'>
              <CustomButton onClick={() => {
                const dataTempt = form.getFieldsValue()
                const resultSearch = Object.fromEntries(
                  Object.entries(dataTempt).filter(([key, value]) => {
                    if (key === 'isExchangeReward') {
                      return true
                    }
                    return !!value
                  })
                )
                setDataPaging({
                  ...resultSearch,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit()
                tableRef.current?.reload();
              }} type='primary'>Tra cứu</CustomButton>
            </div>
          </SearchForm>

          <CustomProTable
            bordered
            rowKey={'stt'}
            columns={columns}
            dataSource={dataTable}
            options={false}
            scroll={{ x: 1300, y: 450 }}
            tableAlertRender={false}
            actionRef={tableRef}
            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={reportState.loading}
                onClick={async () => {
                  setReportState({ loading: true });
                  const { paging, ...rest } = dataPaging
                  await exchangeRewardsPresenter.exportSearchReward(rest)
                  setReportState({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });
              return {
                data: data,
                success: exchangeRewardsStore.listManageRes.isSuccess,
              };
            }}
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: exchangeRewardsStore.listManageRes.paging?.totalCount,
            }}
          />


        </BoxContainer>

      </PageWrapper>
    )
  })
}

export default createUpdatePage